/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskGradeInputDimGrades } from './taskGradeInputDimGrades';
import type { TaskGradeInputSubEvaluations } from './taskGradeInputSubEvaluations';

/**
 * Per-task evaluation payload for the grade-preview endpoint.

For regular essay tasks: provide dim_grades.
For oral exam tasks: provide sub_evaluations (dim_grades is ignored / left empty).
 */
export interface TaskGradeInput {
  taskId: string;
  gradingCategoryId: string;
  dimGrades?: TaskGradeInputDimGrades;
  subEvaluations?: TaskGradeInputSubEvaluations;
}
